import { FC } from 'react'
import LoadableImage from '../../LoadableImage'

import './MultiselectInput.scss'

const ListItems: FC<any> = ({ setValue, options, selectProps, value, ...rest }) => {
  let isEmpty = true

  const filteredOptions = options.filter((option: any) => {
    return !value.find((selected: any) => {
      return selected.value === option.value
    })
  })

  const onChange = (option: any) => {
    selectProps.value ? setValue([...selectProps.value, option]) : setValue([option])
  }
  return (
    <div key={'multiselect-input__menu-list'} className='multiselect-input__menu-list'>
      {filteredOptions.map((option: any, key: any) => {
        const searchValue = selectProps.inputValue ? selectProps.inputValue.toLowerCase() : ''
        const match = option.label.toLowerCase().match(searchValue)
        if (!searchValue || match) {
          if (isEmpty) isEmpty = false
          return (
            <div key={`option-member-${option.member.id}`}>
              {!!key && <div className='option-member__br' />}
              <div
                className='option-member'
                key={option.member.id}
                onClick={() => onChange(option)}
              >
                <div className='option-member__avatar-wrapper'>
                  <LoadableImage isDisableAnimation={true} media={option.member.avatar} />
                </div>
                <div className='option-member__data'>
                  <div className='option-member__data__name'>{option.member.name}</div>
                  <div className='option-member__data__position'>{option.member.displayRole}</div>
                </div>
              </div>
            </div>
          )
        }
        if (isEmpty && filteredOptions.length === key + 1) {
          return (
            <div className='multiselect-input__menu-list__option' key={option.value}>
              Not found
            </div>
          )
        }
        return null
      })}
      {!filteredOptions.length && (
        <div className='multiselect-input__menu-list__option'>No options</div>
      )}
    </div>
  )
}

export default ListItems
